module.exports = __webpack_public_path__ + "static/media/public-sector-square.03fb1ab0.jpg";